<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Environments</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Environments -->
  <div class="environmentGridContainer">
    <ag-grid-angular #agGrid class="ag-theme-alpine environmentGrid" [gridOptions]="gridOptions">
    </ag-grid-angular>
  </div>
  <!-- Update Environment, Delete Environment, Create DevOps Action -->
  <div class="button-div">
    <button mat-raised-button class="button-action" (click)="openUpdateEnvironment()"
      [disabled]="canUpdateEnvironment()">
      <mat-icon>open_in_new</mat-icon>
      Update Environment
    </button>
    <button mat-raised-button color="warn" class="button-action" (click)="deleteEnvironment()"
      [disabled]="canDeleteEnvironment()">
      <mat-icon>delete_forever</mat-icon>
      Delete Environment
    </button>
    <!-- Schedule DevOps Action-->
    <mat-form-field class="button-action">
      <mat-label>Action Name</mat-label>
      <mat-select [(ngModel)]="selectedDevOpsAction" name="actionName">
        <mat-option *ngFor="let item of devOpsActions" [value]="item" [disabled]="!item.isEnabled">
          <span>{{item.actionName}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button class="button-action" mat-raised-button color="primary" (click)="openCreateDevOpsAction()"
      [disabled]="canCreateDevOpsAction()">
      <mat-icon>open_in_new</mat-icon>
      Create DevOps Action
    </button>
  </div>

  <!-- Selected environment -->
  <div *ngIf="selectedEnvironment">
    <p>
      <strong>Environment Id: </strong>
      <a
        [routerLink]="['/erm/environments', selectedEnvironment.environmentId]">{{selectedEnvironment.environmentId}}</a>
    </p>
    <pre>{{selectedEnvironment | json}}</pre>
  </div>
</div>